import { render, staticRenderFns } from "./MemberAreaComments.vue?vue&type=template&id=0eb7c155&scoped=true&"
import script from "./MemberAreaComments.vue?vue&type=script&lang=js&"
export * from "./MemberAreaComments.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaComments.vue?vue&type=style&index=0&id=0eb7c155&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb7c155",
  null
  
)

export default component.exports